var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_141_650",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 256,
    height: 257
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.501709,
    width: 256,
    height: 256,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_141_650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 235.169C113.245 235.169 99.3779 232.369 86.4002 226.769C73.4224 221.169 62.1335 213.569 52.5335 203.969C42.9335 194.369 35.3335 183.08 29.7335 170.102C24.1335 157.124 21.3335 143.257 21.3335 128.502C21.3335 113.746 24.1335 99.8796 29.7335 86.9019C35.3335 73.9241 42.9335 62.6352 52.5335 53.0352C62.1335 43.4352 73.4224 35.8352 86.4002 30.2352C99.3779 24.6352 113.245 21.8352 128 21.8352C142.756 21.8352 156.622 24.6352 169.6 30.2352C182.578 35.8352 193.867 43.4352 203.467 53.0352C213.067 62.6352 220.667 73.9241 226.267 86.9019C231.867 99.8796 234.667 113.746 234.667 128.502C234.667 143.257 231.867 157.124 226.267 170.102C220.667 183.08 213.067 194.369 203.467 203.969C193.867 213.569 182.578 221.169 169.6 226.769C156.622 232.369 142.756 235.169 128 235.169ZM128 213.835C137.6 213.835 146.845 212.28 155.733 209.169C164.622 206.057 172.8 201.569 180.267 195.702L60.8002 76.2352C54.9335 83.7019 50.4446 91.8796 47.3335 100.769C44.2224 109.657 42.6668 118.902 42.6668 128.502C42.6668 152.324 50.9335 172.502 67.4668 189.035C84.0002 205.569 104.178 213.835 128 213.835ZM195.2 180.769C201.067 173.302 205.556 165.124 208.667 156.235C211.778 147.346 213.333 138.102 213.333 128.502C213.333 104.68 205.067 84.5019 188.533 67.9685C172 51.4352 151.822 43.1685 128 43.1685C118.4 43.1685 109.156 44.7241 100.267 47.8352C91.3779 50.9463 83.2002 55.4352 75.7335 61.3019L195.2 180.769Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoAccess);
export default __webpack_public_path__ + "static/media/ICON_NO_ACCESS.d9e26d7792913e0341762d6771180fe2.svg";
export { ForwardRef as ReactComponent };